import SubjectHeader from '../../components/SubjectHeader/SubjectHeader';
import NoLiveSessions from '../../components/NoLiveSessions/NoLiveSessions';
import { useEffect, useState, SyntheticEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CreateQuiz from '../../components/CreateQuiz/CreateQuiz';
import DocumentCard from '../../components/DocumentCard/DocumentCard';
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_QUIZ, UPDATE_QUIZ, DELETE_QUIZ, GET_QUIZ_RESULTS } from "../../pages/Quiz/api/QuizQuery";
import ToasterWithMessage from '../../components/toaster';
import CustomTab from '../CustomTab/CustomTab';
import { useAppSelector } from '../../redux/app/hooks';
import ConfirmationPopup from '../../components/ConfirmationPopup/ConfirmationPopup';
import images from "../../assets/images";
import './Quiz.scss';
import Loader from '../../components/Loader/Loader';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import QuizResultsTeacher from '../../components/QuizResultsTeacher/QuizResultsTeacher';
import ViewPage from '../../components/ViewPage/ViewPage';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import { trackButtonClick } from '../../firebase/analyticsHelper';
import { ButtonClickEvents } from '../../firebase/constants/events';

type Options = {
  option_A: string;
  option_B: string;
  option_C?: string;
  option_D?: string;
  option_E?: string;
  option_F?: string;
}

export type questions = {
  qs_id: string;
  qs_info: string;
  question_id?:string;
  is_correct: string;
  options: Options;
  question: string;
  isCorrectAnswer: boolean;
  chosen_option: string;
}

export type Students = {
  studentAvatarUrl: string;
  studentId: string;
  studentName: string;
  totalScore: number;
}

export type QuizData = {
  quizId: string;
  isClassroom: boolean;
  createdAt: string;
  quizTitle: string;
  updatedAt: string;
  questions: questions[];
  status: string;
  totalScore: number;
  totalQuestions: number;
  totalCompletedStudents?: number;
  students: Students[];
  questionsCount: number;
  results: any[];
  feedId : string
}

const Quiz = () => {
  const {state} = useLocation();
  const [showCreate,setShowCreate] = useState<boolean>(false);
  const [quizData, setQuizData] = useState<QuizData[]>([]);
  const [activeTab, setActiveTab] = useState<number>(0);
  const [selectedQuiz, setSelectedQuiz] = useState<QuizData | undefined>();
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [action, setAction] = useState<string>('');
  const [refetch, setRefetch] = useState<boolean>(false);
  const { success, error } = ToasterWithMessage();
  const { ShareGif, DeleteGif, docsImg, quizStudent, quizIcon } = images;
  const role = useAppSelector((state) => state.auth.role);
  const labels = [ "Quiz", "Results" ];
  const navigate = useNavigate();
  const backNavigation = ( role === STUDENT_ROLE ) ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH;
  const [showResults, setShowResults] = useState<boolean>(false);
  const [showQuizDetail, setShowQuizDetail] = useState<boolean>(false);
  const [subCategory, setSubCategory] = useState<string>();
  const [isEdit, setIsEdit] = useState<boolean>(false);  
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const [openReminder, setOpenReminder] = useState<boolean>(false);

  const onYesReminder = () => {
      setOpenReminder(false);
      setOpenConfirmationPopup(true);
  }

  const [getAllQuiz, { loading }] = useLazyQuery(GET_QUIZ, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setQuizData(data?.getAllQuizzes?.allquizzes);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
            if (role === STUDENT_ROLE) {
                navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH);
            } else {
                navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_QUIZ_PATH);
            }
        }, 2000);
      }
    }
  })

  const [readquizFeed] = useMutation(READ_CLASSROOMUPDATES, {
    fetchPolicy: FETCH_POLICY,
    onCompleted : (data) =>{
    },
    onError: (err) =>{
      console.log(err.message)
    }
  })

  useEffect(()=>{
if(role === STUDENT_ROLE){
  if(quizData.length > 0){
    quizData?.forEach((data) => {
      if (data.feedId) {
        readquizFeed({
          variables: {
            fId: data.feedId,
            uId: profile?.getCurrentUser?.nodes[0]?.uId
          }
        })
      }
    });
  }
}
  },[profile?.getCurrentUser?.nodes, quizData, readquizFeed, role])

  const [getQuizResults, { loading: loadingResults  }] = useLazyQuery(GET_QUIZ_RESULTS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setQuizData(data?.getQuizResults?.nodes);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
            if (role === STUDENT_ROLE) {
                navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH);
            } else {
                navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_QUIZ_PATH);
            }
        }, 2000);
      }
    }
  })
  
  const [updateQuiz] = useMutation(UPDATE_QUIZ, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: () => {
      setRefetch(!refetch);
      success(`${action === "share" ? "Shared" : "Unshared"} successfully`);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
            if (role === STUDENT_ROLE) {
                navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH);
            } else {
                navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_QUIZ_PATH);
            }
        }, 2000);
      }
    }
  })

  const [deleteQuiz] = useMutation(DELETE_QUIZ, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: () => {
        setRefetch(!refetch);
        success("Deleted successfully");
      },
      onError: (err) => {
        error(err?.message);
        if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
          setTimeout(() => {
              if (role === STUDENT_ROLE) {
                  navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH);
              } else {
                  navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_QUIZ_PATH);
              }
          }, 2000);
        }
      }
  })

  const handleQuizActions = (selectedQuiz: QuizData, action: string) => {
    if (selectedQuiz) {
      if (action === "delete") {
        deleteQuiz({
            variables: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                qzId: selectedQuiz?.quizId,
            }
        })
      }
      else if(action === "share" || action === "unshare") {
        updateQuiz({
            variables: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                qzId: selectedQuiz?.quizId,
                isClassroom: !selectedQuiz?.isClassroom
            }
        });
      }
    }
  }

  const onYesButtonClick = () => {
      setOpenConfirmationPopup(false);
      if (selectedQuiz) {
          handleQuizActions(selectedQuiz, action)
      }
  }

  const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
  }
  
  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setShowResults(false);
    setShowQuizDetail(false);
    setSubCategory('');
  };

  const handleClick = (action: string, quiz: QuizData) => {
    console.log("action", action);
    setAction(action);
    if (action === "unshare") {
      handleQuizActions(quiz, action)
    }
    else if (action === "edit") {
      setIsEdit(true);
      setShowCreate(true);
    } else if (action === 'share') {
      setOpenReminder(true);
    }
    else {
      setOpenConfirmationPopup(true);
    }
    setSelectedQuiz(quiz);
  }

  const handleClickCard = (item: QuizData, isDisableView: boolean) => {
    setSelectedQuiz(item);
    const setState = { ...state, data: item, backNavigation: { path: PATH_ADDRESSES?.STUDENT_CLASSROOM_QUIZ_PATH, state: state } }
    if ( role === STUDENT_ROLE ) {
      if (item?.status !== "COMPLETED") {
        navigate('/student-classroom/quiz/test', { 
          state: setState
        });
      }
      else {
        navigate('/student-classroom/quiz/view', { 
          state: setState
        });
      }
    }
    else if ( role === TEACHER_ROLE) {
      setSubCategory(item?.quizTitle);
      if (!isDisableView ) {
        if (activeTab === 0) {
          setShowResults(false);
          setShowQuizDetail(true);
        }
        else {
          setShowResults(true);
          setShowQuizDetail(false);
        }
      }
    }
  }

  useEffect(() => {
    if (!showResults && !showCreate && !showQuizDetail) {
      setSubCategory('');
      setRefetch(!refetch);
    }
  }, [showResults, showCreate, showQuizDetail,state])
  
  useEffect(() => {
    if (selectedClassRoomId && selectedSubjectId) {
      if (activeTab === 0 ) {
        getAllQuiz({
          variables: {
            input : {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              limit: null,
              offset: null
            }
          }
        });
      }
      else {
        getQuizResults({
          variables: {
            cId: selectedClassRoomId,
            sjId: selectedSubjectId,
            limit: null,
            offset: null
          }
        })
      }
    }
  },[activeTab, refetch, showCreate])
  
  return (
    <>
    <div className='quizMainContainer'>
      <div className='quizHeader'>
        <SubjectHeader 
          headerName = {state?.title} 
          subCategory={subCategory} 
          headerImage={state?.imageSrc} 
          backgroundColor={state?.backGroundColor}
          backNavigation={{ path: backNavigation, state: state }} 
          showCreateScheduling={showCreate} 
          setShowCreateScheduling = {setShowCreate} 
          tabName={'Quiz'} 
          {...(showResults && { setShowResults: setShowResults })} 
          {...(showQuizDetail && { setShowResults: setShowQuizDetail })}
          {...(isEdit && { setIsEdit: setIsEdit })}
        />

        { (role !== STUDENT_ROLE && showCreate && !getScreenDimensions().isMobileScreen) && <button type="submit" form="createQuizForm" className="submitButtonQuiz">Submit</button>}
        { (role !== STUDENT_ROLE && !showCreate && !showQuizDetail && quizData?.length > 0) && 
          (<div className='quizTabContainer'>
            <CustomTab activeTab={activeTab} handleChangeTab={handleChangeTab} labels={labels} />
          </div>)
        }
      </div>
      {(loading || loadingResults) ? <Loader bottom='110px' /> : 
        <>
          { (!showCreate && quizData.length === 0) && <NoLiveSessions setShowCreateScheduling={setShowCreate} tabName={'Quiz'} /> }
         { showCreate && <div className='createquiz-mobile-container'>
          { (showCreate) && <CreateQuiz setShowCreate={setShowCreate} isEdit={isEdit} setIsEdit={setIsEdit} selectedQuiz={selectedQuiz} setSelectedQuiz={setSelectedQuiz} /> }
         { (role !== STUDENT_ROLE && showCreate && getScreenDimensions().isMobileScreen) && <button type="submit" form="createQuizForm" className="submitButtonQuiz">Save</button>}
          </div>}
          { (!showCreate && !showResults && !showQuizDetail && quizData.length > 0) && 
            <div className={`QuizCardContainer ${ (role === TEACHER_ROLE && activeTab === 1)  ? "QuizCardContainerResult" : ""} ${role === STUDENT_ROLE ? "studentQuizCardContainer":""} " ` } >
             { quizData.map((item: QuizData) => <DocumentCard image={activeTab === 0 ? docsImg : quizStudent} data={item} tabName={activeTab === 0 ? "Quiz" : "Results"} handleClickShareDelete={handleClick} handleClickCard={handleClickCard} />)}
            </div>
          }

          { (showResults && !showQuizDetail) && <QuizResultsTeacher selectedQuiz={selectedQuiz} /> }

          { (showQuizDetail && !isEdit && !showResults) && <ViewPage data={selectedQuiz} /> }

          { (role !== STUDENT_ROLE && !showCreate && !showQuizDetail && activeTab === 0 && quizData.length > 0) && (
            <div className="QuizCreateBtn">
              <button className='createButtonStyle' onClick={() => {trackButtonClick(ButtonClickEvents?.QUIZ_CREATE_BUTTON_CLICK, { description: "User clicked create button in quiz", page: "Teacher Quiz" }); setShowCreate(true);}}>Create</button>
            </div>
          )}
        </>
      }

      <ConfirmationPopup
          open={openConfirmationPopup}
          message={action === "share" ? `Are you sure you want to Share this file with your Classroom?` : `Are you sure you want to Delete this file from the Classroom?`}
          gifData={action === "share" ? ShareGif : DeleteGif}
          yesButtonFunctionality={onYesButtonClick}
          noButtonFunctionality={onNoButtonClick}
          messageWidth={'195px'}
      />
    </div>
    <ConfirmationPopup
      open={openReminder}
      page={`quiz`}
      gifData={quizIcon}
      message={`Please ensure that a correct answer is selected for each question before sharing the quiz.`}
      yesButtonFunctionality={onYesReminder}
      messageWidth={'300px'}
    />
    </>
  )
}

export default Quiz;